import dayjs from 'dayjs';
import { OrderStatus } from './enums';

export function orderHasExpiredDate(status: OrderStatus, latestDate: string | null) {
  const hasTradedStatus = status === OrderStatus.Traded;
  const isAfterDeliveryDate = dayjs().isAfter(latestDate, 'day');

  return hasTradedStatus && isAfterDeliveryDate;
}
